import { useEffect, useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { getPage } from "../lib/api";

export default function Legal({ slug }) {
  const [page, setPage] = useState(null);
  useEffect(() => { getPage(slug).then(setPage).catch(() => {}); }, [slug]);

  return (
    <div data-testid={`${slug}-page`}>
      <Seo title={page?.seo?.title || (page?.title ? `${page.title} — Lemur Quality` : undefined)} description={page?.seo?.description} />
      <PageHeader eyebrow={page?.eyebrow || "Legal"} title={page?.title || ""} lead={page?.lead} crumb={page?.title} />
      <section className="section bg-paper">
        <div className="wrap">
          <Reveal className="legal">
            {page?.updated && <p className="updated">Last updated: {page.updated}</p>}
            {page?.sections?.map((b, i) => (
              <div key={i}>
                <h2>{b.heading}</h2>
                {b.paragraphs.map((para, j) => <p key={j}>{para}</p>)}
              </div>
            ))}
          </Reveal>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
